import { render, staticRenderFns } from "./SingleProvider.vue?vue&type=template&id=0e0291f7&"
import script from "./SingleProvider.vue?vue&type=script&lang=js&"
export * from "./SingleProvider.vue?vue&type=script&lang=js&"
import style0 from "./SingleProvider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports